import React, { FC } from 'react';
import { BoxProps, Text } from '@chakra-ui/react';

interface UnderlineLinkProps extends BoxProps {
  href?: string;
  children?: React.ReactNode;
}

export const UnderlineLink: FC<UnderlineLinkProps> = ({ children, ...props }) => (
  <Text
    transition='opacity 0.2s'
    cursor='pointer'
    color='brand.500'
    _hover={{ opacity: 0.8 }}
    _after={{
      content: '""',
      display: 'block',
      w: 'full',
      h: '2px',
      bottom: 0,
      bg: 'orange.500',
      insetX: 0,
      insetY: 0
    }}
    {...props}
  >
    {children}
  </Text>
);
